// extracted by mini-css-extract-plugin
export default {"icon-nav":"buttonStyles-icon-nav_kZ_","cls2":"buttonStyles-cls2_cXf buttonStyles-cls1__kB","cls1":"buttonStyles-cls1__kB"};